<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div style="max-height: 200px; overflow-y: auto; float: left;
                    width: calc(100% - 59px);">
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                        item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="货件编号：" class="item">
                <el-input
                  v-model="form.shipmentId"
                  class="input"
                  size="small"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="SKU：" class="item">
                <el-input
                  v-model="form.merchantSku"
                  class="input"
                  size="small"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="ASIN：" class="item">
                <el-input
                  v-model="form.asin"
                  class="input"
                  size="small"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="状态：" class="item">
                <el-select
                  clearable
                  v-model="form.fbaImpStatus"
                  placeholder=""
                  class="input"
                  style="width: 100%"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['fbaImpStatus']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="导入时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.payTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left">
          <el-button
            type="primary"
            size="small"
            @click="hanbleCreateFba"
            v-if="user.userType !== '00'"
          >
            导入发货计划
          </el-button>
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table
        id="myOrder"
        ref="table"
        :data="tableData"
        class="table"
        :default-expand-all="true"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              ref="detailTable"
              class="table"
              border
              :data="[props.row]"
              :show-header="false"
            >
              <el-table-column :width="orderWidth">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="left">
                        <el-popover placement="bottom" trigger="hover">
                          <img
                            style="width: 320px; height: 320px"
                            :src="item.picUrl ? item.picUrl : noImage"
                          />
                          <img
                            class="mini-img"
                            :src="item.picUrl ? item.picUrl : noImage"
                            slot="reference"
                          />
                        </el-popover>
                      </div>
                      <div class="right">
                        <div
                          style="line-height: 15px; margin: 2px 0 0 0"
                          v-if="item.title"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${item.title}`"
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 329px"
                              :style="{ width: orderWidth - 140 + 'px' }"
                            >
                              <span> {{ item.title }}</span>
                            </div></el-tooltip
                          >
                        </div>
                        <div :title="item.merchantSku" class="text-ellipsis">
                          {{ item.merchantSku }}
                        </div>
                        <div
                          style="
                            color: #4934b2;
                            cursor: pointer;
                            line-height: 15px;
                            margin: 2px 0 0 0;
                          "
                          @click="handleOpenDetail(item)"
                          v-if="item.proName"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${item.proName}${
                              item.designId ? '（' + item.designId + '）' : ''
                            }`"
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 329px"
                              :style="{ width: orderWidth - 140 + 'px' }"
                            >
                              <span> {{ item.proName }}</span>
                              <span v-if="item.designId">
                                ({{ item.designId }})</span
                              >
                            </div></el-tooltip
                          >
                        </div>
                        <div
                          :title="item.properVal"
                          class="text-ellipsis"
                          v-if="item.properName"
                        >
                          <span v-if="item.properName && item.properVal">
                            <span
                              v-for="(i, ind) in [0, 1]"
                              :key="'i_' + ind"
                              style="margin-right: 10px"
                            >
                              {{ item.properName.split(":")[i] }}：
                              {{ item.properVal.split(":")[i] }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="right">
                        <div style="line-height: 15px; margin: 2px 0 0 0">
                          <div
                            class="text-ellipsis"
                            style="
                              display: inline-block;
                              width: 83px;
                              padding: 47px 0 0 0;
                            "
                          >
                            <span> {{ item.shipped }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="128" align="center">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="right">
                        <div style="line-height: 15px; margin: 2px 0 0 0">
                          <div
                            class="text-ellipsis"
                            style="
                              display: inline-block;
                              width: 90px;
                              padding: 47px 0 0 0;
                              text-align: center;
                            "
                          >
                            <span> {{ item.asin }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="230" align="center">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="right">
                        <div style="line-height: 15px; margin: 2px 0 0 0">
                          <div
                            class="text-ellipsis"
                            style="
                              display: inline-block;
                              width: 230px;
                              padding: 39px 0 0 0;
                              text-align: center;
                            "
                          >
                            <div
                              class="loan-wrap"
                              style="
                                text-align: center;
                                margin: 0 0px 8px -16px;
                              "
                            >
                              {{ dictMap["fbaImpStatus"][item.fbaImpStatus] }}
                            </div>
                            <div
                              class="loan-wrap"
                              style="text-align: center; margin: 0 0 0 -16px"
                            >
                              导入时间：{{ item.importTimeStr }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="170" align="center">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="right">
                        <div style="line-height: 15px; margin: 2px 0 0 0">
                          <div
                            class="text-ellipsis"
                            style="
                              display: inline-block;
                              width: 170px;
                              padding: 39px 0 0 0;
                              text-align: center;
                            "
                          >
                            <div
                              class="loan-wrap"
                              style="text-align: center; margin: 0 0 0 -16px"
                            >
                              {{ item.appNo }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.productList"
                      :key="index"
                    >
                      <div class="right" style="width: 100%">
                        <div style="line-height: 15px; margin: 2px 0 0 0">
                          <div
                            class="text-ellipsis"
                            style="
                              display: inline-block;
                              padding: 47px 0 0 0;
                              text-align: center;
                            "
                          >
                            <span
                              v-if="item.fbaImpStatus == '01'"
                              class="link"
                              @click="handleRelate(item)"
                            >
                              关联
                            </span>
                            <span
                              v-else-if="
                                item.fbaImpStatus == '02' ||
                                item.fbaImpStatus == '03'
                              "
                              class="link"
                              @click="handleCreatePayOrder(item)"
                            >
                              生成付款单
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="产品信息" align="left" :width="orderWidth - 46">
          <template slot-scope="scope" style="cursor: pointer">
            <div>
              货件编号：<span
                @click="handleEdit(scope.row)"
                style="color: #4934b2; cursor: pointer"
                >{{ scope.row.shipmentId }}</span
              ><span>（{{ scope.row.planName }}）</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          align="center"
          width="109"
        ></el-table-column>
        <el-table-column
          label="ASIN"
          align="center"
          width="109"
        ></el-table-column>
        <el-table-column
          width="230"
          label="状态/时间"
          align="center"
        ></el-table-column>
        <el-table-column width="170" label="订单号" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center"></el-table-column>
        <el-table-column label="" align="center">
          <template slot-scope="scope">
            <div
              style="
                text-align: right;
                padding: 0 16px 0 0;
                position: absolute;
                right: 24px;
                top: 12px;
                width: 300px;
              "
            >
              {{ dictMap["plat_no"][scope.row.platNo] || "" }}：{{
                scope.row.shopName
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="导入发货计划"
      :visible.sync="dialogVisible"
      destroy-on-close
    >
      <div>
        <el-form
          ref="uploadForm"
          :model="fbaForm"
          :rules="uploadRules"
          label-width="117px"
          size="small"
        >
          <el-form-item label="选择店铺：" prop="typeId">
            <el-select
              clearable
              filterable
              v-model="fbaForm.shopId"
              placeholder="请选择店铺名称"
              class="input"
              size="small"
            >
              <el-option
                v-for="(item, index) in shopList"
                :key="index"
                :label="item.shopName"
                :value="item.shopId"
                >{{ item.shopName
                }}<span v-if="item.amazonSite"
                  >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入发货计划：">
            <el-upload
              ref="upload"
              drag
              action="#"
              :file-list="fileList"
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-change="handleChange"
              :limit="1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleUploadFile"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <FbaRelate
      :visible="showEdit"
      :order="currentOrder"
      @onOk="handleRelateOk"
      @onClose="hideEdit"
    />
    <FbaPlan :visible="showDetail" :order="currentOrder" @close="handleClose" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import { listPlan, uploadPlan, createOrder } from "@/api/order/fba"
import { getShopList } from "@/api/system/shopManage"
import noImage from "@/assets/images/no_image.png"
import FbaRelate from "./components/FbaRelate"
import FbaPlan from "./components/FbaPlan"

export default {
  name: "fbaOrder",
  components: {
    Breadcrumb,
    FbaRelate,
    FbaPlan,
  },
  data() {
    return {
      form: {
        shipmentId: "", // 平台渠道
        asin: "", // 来源国家
        merchantSku: [],
        shopId: [], // 店铺名称
        fbaImpStatus: "", // 订单状态
        payTime: "", // 订单编号
        pageNum: 1,
        pageSize: 10,
      },
      fbaForm: {
        shopId: "",
      },
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showEdit: false,
      showRemark: false,
      showCopy: false,
      showEditSale: false,
      currentOrder: {},
      currentAppId: "",
      shopList: [],
      roles: [],
      sumMoney: 0,
      dialogVisible: false,
      isCheckShop: true,
      noImage: noImage,
      fileList: [],
      uploadRules: [],
      showDetail: false,
      isExpand: false,
      shopName: "",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    ...mapGetters(["user"]),
    orderWidth() {
      let width = document.body.clientWidth
      let orderWidth = "476"
      if (width > 1500) {
        orderWidth = "476"
      } else {
        orderWidth = "339"
      }
      return orderWidth
    },
  },
  mounted() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.form.payTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.getData()
    this.getShops()
    this.roles = this.user.roles
  },
  methods: {
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleOpenDetail(row) {
      if (row.designId) {
        let routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        })
        window.open(routeUrl.href, "_blank")
      }
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    // 搜索
    getData() {
      this.startLoading()
      let params = Object.assign({}, this.form)

      if (this.form.payTime && this.form.payTime.length > 0) {
        params["importBgnTime"] = dayjs(this.form.payTime[0]).format(
          "YYYY-MM-DD"
        )
        params["importEndTime"] = dayjs(this.form.payTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      params.shopId = params.shopId.join(",")

      if (params.shopId == "" && this.isCheckShop) {
        let shopId = []
        for (let record of this.shopList) {
          shopId.push(record.shopId)
        }
        params.shopId = shopId.join(",")
      }
      // params.amazonOrderStatus = params.amazonOrderStatus.join(",")

      delete params["payTime"]
      delete params["shopId"]

      listPlan(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败")
          } else {
            this.total = res.total
            this.tableData = res.rows
            this.sumMoney = res.data.totalSaleActPay
          }
          this.endLoading()
        })
        .catch(() => [this.endLoading()])
    },
    // 重置
    reset() {
      this.form = {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        payTime: [],
        shopId: [], // 店铺名称
        amazonOrderStatus: [], // 订单状态
        appNo: "", // 订单编号
        asin: "",
        pageNum: 1,
        pageSize: 10,
      }
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    async handleUploadFile() {
      if (!this.fbaForm.shopId) {
        this.msgError("请选择店铺")
        return
      }
      if (this.fileList.length == 0) {
        this.msgError("请选择文件")
        return
      }
      let fileList = this.fileList
      let formData = new FormData()
      formData.append("file", this.fileList[0].raw)
      formData.append("shopId", this.fbaForm.shopId)
      try {
        let result = await uploadPlan(formData)
        this.msgSuccess("导入成功")
        this.getData()
      } catch (error) {}

      this.dialogVisible = false
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    // 编辑订单
    handleRelate(data) {
      this.showEdit = true
      this.currentOrder = data
    },
    hideEdit() {
      this.showEdit = false
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    handleClose() {
      this.showDetail = false
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    hanbleCreateFba() {
      this.dialogVisible = true
      this.fbaForm.shopId = ""
      this.fileList = []
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!")
      }
      return isLt2M
    },
    closeImgClassification() {
      this.classificationVisible = false
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    handleEdit(row) {
      this.currentOrder = row
      this.showDetail = true
    },
    handleRelateOk() {
      this.showEdit = false
      this.getData()
    },
    handleCreatePayOrder(item) {
      this.$confirm("确定生成付款单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let result = await createOrder({
          skuId: item.skuId,
          fbaPlanId: item.fbaPlanId,
        })
        this.getData()
        this.msgSuccess(
          "成功生成付款单，请到我的订单，编辑完善收货地址、物流方式，并付款"
        )
      })
    },
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 97px;
  height: 97px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
  height: 123px;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.link {
  font-size: 12px;
  color: #4934b2;
  cursor: pointer;
}

.table /deep/.el-table_1_column_1 {
  width: 0px !important;
  height: 0px !important;
}

.table /deep/.el-table_1_column_1 .cell {
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*="cell"] {
  padding: 8px 16px;
}
.table-body /deep/ .expanded {
  background: #f5f7fa;
}
</style>
